import { createSelector } from 'reselect';

const getState = (state) => state.recurringOrdersEdit;

const getRecurringOrder = createSelector(getState, (state) => state.initialRecurringOrder);
const getPreviewChanges = createSelector(getState, (state) => state.previewChanges);
const getMainLoading = createSelector(getState, (state) => state.mainLoading);
const getIsPreviewModalOpened = createSelector(getState, (state) => state.previewModalOpened);
const getPreviewModalMode = createSelector(getState, (state) => state.previewModalMode);
const getPreviewModalLoading = createSelector(getState, (state) => state.previewModalLoading);
const getPreviewModalSubmitting = createSelector(getState, (state) => state.previewModalSubmitting);

export {
  getRecurringOrder,
  getMainLoading,
  getIsPreviewModalOpened,
  getPreviewChanges,
  getPreviewModalMode,
  getPreviewModalLoading,
  getPreviewModalSubmitting,
};
